module.exports = __webpack_public_path__ + "static/media/investigation committee.e62c8957.svg";